var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_587_22757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 12.5C24.3856 12.2812 24.6454 12.1076 24.9314 11.9891C25.2173 11.8707 25.5238 11.8097 25.8334 11.8097C26.1429 11.8097 26.4494 11.8707 26.7353 11.9891C27.0213 12.1076 27.2812 12.2812 27.5 12.5C27.7189 12.7189 27.8925 12.9788 28.011 13.2647C28.1294 13.5507 28.1904 13.8572 28.1904 14.1667C28.1904 14.4762 28.1294 14.7827 28.011 15.0687C27.8925 15.3547 27.7189 15.6145 27.5 15.8334L16.25 27.0834L11.6667 28.3334L12.9167 23.75L24.1667 12.5Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--mui-palette-icon-teal, #036A8B)"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_587_22757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c1d4657a2e9772777cef907b2a3fe567.svg";
export { ForwardRef as ReactComponent };